export default "__VITE_ASSET__BSItPye7__"